/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  output,
  signal
} from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { GlobalFacade } from '~backoffice/app/~store/facades/global.facade';
import { PageName } from '../../models/shared.models';
import { TimeRangeName, TimeRangeObject } from '~core/models/shared.models';
import { DashboardFacade } from '~backoffice/app/~store/facades/dashboard.facade';

@Component({
  selector: 'page-header',
  standalone: false,
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderComponent implements OnInit {
  private _globalFacade = inject(GlobalFacade);
  private _dashboardFacade = inject(DashboardFacade);
  private _router = inject(Router);

  enableDateRangeFilter = input<boolean>(true);
  initialTimeRangeName = input<TimeRangeName>(TimeRangeName.ANYTIME);

  dateTimeRangeChange = output<{
    startDateTime: string;
    endDateTime: string;
  }>();

  protected readonly timeRangeNameEnum = TimeRangeName;
  breadcrumbs = signal<{ label: string; url: string }[]>([]);

  headerTitle$ = this._globalFacade.routeData$.pipe(
    map(routeData =>
      routeData ? (routeData.data?.pageName as PageName | undefined) : undefined
    )
  );

  headerBreadcrumb$ = this._globalFacade.routeData$.pipe(
    map(routeData =>
      routeData ? (routeData.data?.breadcrumb as string | undefined) : undefined
    )
  );

  ngOnInit(): void {
    this._buildBreadcrumbs();
  }

  setDateTimeRange(
    range: TimeRangeObject,
    timeRangeName: TimeRangeName | null
  ): void {
    this._dashboardFacade.setResourceTimeRange(
      timeRangeName === TimeRangeName.ANYTIME ? null : range
    );
  }

  private _buildBreadcrumbs(): void {
    const crumbs: { label: string; url: string }[] = [];
    let route = this._router.routerState.snapshot.root;
    let url = '';

    while (route.firstChild) {
      route = route.firstChild;
      const path = route.url.map(s => s.path).join('/');
      if (path) url += '/' + path;

      const label = route.data['breadcrumbs'] as string | undefined;
      if (label && !crumbs.some(c => c.label === label)) {
        crumbs.push({ label, url: url || '/' });
      }
    }

    this.breadcrumbs.set(crumbs);
  }
}
